const defaultAdsLabelStyles = {
  position: 'relative !important',
  padding: '.8px 4px !important',
  margin: '0 5px 0 0 !important',
  background: 'transparent !important',
  color: '#78718a !important',
  lineHeight: '1.364 !important',
  fontSize: '10px !important',
  fontWeight: '400 !important',
  fontFamily: 'Segoe UI,Segoe WP,Arial,Sans-Serif',
  border: '.5px solid #78718a !important',
  borderRadius: '4px !important',
};

export const getMmaInMsanPlacementBaseStyles = () => ({
  placementCard: undefined,
  placementImageContainer: undefined,
  placementTextContainer: undefined,
  placementAdsLabel: undefined,
  placementGradient: undefined,
  placementShortHeadline: undefined,
  placementLongHeadline: undefined,
  placementFinalUrl: undefined,
  placementDescription: undefined,
  placementCallToAction: undefined,
  placementBusinessNameWithAdsLabel: undefined,
});

export const getMmaInMsanWideImage191x100Styles = theme => ({
  // base styles
  ...getMmaInMsanPlacementBaseStyles(theme),

  // overrides
  placementCard: {
    // height: 364,
    color: '#ddd',
    border: 'solid',
    borderWidth: 'thin',
  },

  placementTextContainer: {
    padding: 10,
    color: '#333',
    fontSize: 10,
    lineHeight: '16px',
    maxWidth: '-webkit-fill-available',
  },

  placementShortHeadline: {
    top: -6,
    color: '#207697',
    height: 60,
    position: 'relative',
    fontSize: 18,
    lineHeight: 1.2,
    fontWeight: 200,
    paddingBottom: 5,
  },

  placementDescription: {
    height: 45,
    margin: '5px 0 10px 0',
    fontSize: 14,
  },

  placementBusinessNameWithAdsLabel: {
    '& .ads-label': defaultAdsLabelStyles,
  },
});

export const getMmaInMsanMSEdgeSingleCarousel178x100Styles = theme => ({
  // base styles
  ...getMmaInMsanPlacementBaseStyles(theme),

  placementCard: {
    '&:hover $placementGradient': {
      height: '480px !important',
      top: -100,
    },
    width: '624px !important',
  },

  // overrides
  placementTextContainer: {
    position: 'absolute',
    left: 20,
    bottom: 25,
    fontSize: 10,
    lineHeight: '16px',
    color: '#bebebe',
  },

  placementGradient: {
    display: 'block',
    width: '100%',
    height: '280px !important',
    top: 100,
    backgroundImage: 'linear-gradient(to bottom, transparent 0, black 100%)',
  },

  placementShortHeadline: {
    fontWeight: '200',
    fontSize: 28,
    lineHeight: '33.99px',
    color: 'white',
    width: 590,
    height: 73,
    marginBottom: 20,

    '& .multi-line-processed-text': {
      position: 'absolute',
      bottom: 30,
    },
  },

  placementBusinessNameWithAdsLabel: {
    '& .ads-label': {
      ...defaultAdsLabelStyles,
      color: '#fff !important',
      opacity: '0.7 !important',
      border: '.5px solid hsla(0,0%,100%,.3) !important',
    },
    '& .business-name': {
      color: '#bebebe !important',
    },
  },
});

export const getMmaInMsanMSNInArticle150x100Styles = theme => ({
  // base styles
  ...getMmaInMsanPlacementBaseStyles(theme),

  // overrides
  placementCard: {
    // height: 364,
    color: '#ddd',
    border: 'solid',
    borderWidth: 'thin',
    background: '#fff',
  },

  placementTextContainer: {
    padding: 10,
    // height: 98,
    color: '#333',
    fontSize: 10,
    lineHeight: '16px',
  },

  placementShortHeadline: {
    top: -6,
    color: '#207697',
    height: 60,
    position: 'relative',
    fontSize: 15,
    lineHeight: 1.2,
    fontWeight: 200,
    paddingBottom: 5,
  },

  placementDescription: {
    height: 45,
    margin: '5px 0 10px 0',
    fontSize: 14,
  },

  placementBusinessNameWithAdsLabel: {
    '& .ads-label': defaultAdsLabelStyles,
  },
});

export const getMmaInMsanMSNSmallHeadline133x100Styles = theme => ({
  // base styles
  ...getMmaInMsanPlacementBaseStyles(theme),

  // overrides
  placementCard: {
    width: '300px !important',
    height: 90,
    color: '#ddd',
    // border: 'solid',
    borderWidth: 'thin',
    background: '#fff',
    flexDirection: 'row !important',
  },

  placementImageContainer: {
    float: 'left',
    width: 100,
    height: 75,
    margin: 8,
  },

  placementTextContainer: {
    color: '#333',
    fontSize: 10,
    lineHeight: '16px',
  },

  placementShortHeadline: {
    height: 52,
    margin: '4px 8px 0 8px',
    overflow: 'hidden',
    fontSize: 13,
    fontWeight: 600,
    lineHeight: 1.384,
    paddingBottom: 5,
  },

  placementBusinessNameWithAdsLabel: {
    '& .ads-label': defaultAdsLabelStyles,
  },
});

export const getMmaInMsanSquareImage1x1Styles = theme => ({
  // base styles
  ...getMmaInMsanPlacementBaseStyles(theme),

  // overrides
  placementCard: {
    width: '300px !important',
    height: 90,
    color: '#ddd',
    border: 'solid',
    borderWidth: 'thin',
    background: '#fff',
    flexDirection: 'row !important',
  },

  placementImageContainer: {
    float: 'left',
    width: 80,
    height: 75,
    margin: 8,
  },

  placementTextContainer: {
    color: '#333',
    fontSize: 10,
    lineHeight: '16px',
  },

  placementShortHeadline: {
    height: 45,
    margin: '8px 8px 0 8px',
    overflow: 'hidden',
    fontSize: 13,
    fontWeight: 600,
    lineHeight: 1.384,
    paddingBottom: 5,
  },

  placementBusinessNameWithAdsLabel: {
    '& .ads-label': defaultAdsLabelStyles,
  },
});
